import {useContext} from 'react';
import {IScreenContext, ScreenContext} from '../components/context';

export const useScreen = (): IScreenContext => useContext(ScreenContext)
